// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/normalize.css/normalize.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@blueprintjs/core/lib/css/blueprint.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@blueprintjs/icons/lib/css/blueprint-icons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@blueprintjs/popover2/lib/css/blueprint-popover2.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("play.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
    overflow: hidden;
    font-size: 1rem;
    line-height: 150%;
}

h1 {
    line-height: 1 !important;
}

.pasteInput .bp5-input-group {
    flex: 1 1 !important;
}

.fullControlGroup, .fullControlGroup > .bp5-input-group, .fullControlGroup > .bp5-input-group > input[type=text] {
    width: 100% !important;
}

.fullControlGroup > .bp5-input-group {
    width: 100% !important;
}

.bp5-multi-select {
    overflow: auto !important;
    height: 30px !important;
}

.noPadding {
    padding: 0 !important;
}

.bp5-dark .bp5-html-table .td {
    padding: 11px;
}
.bp5-dark .bp5-html-table.bp5-html-table-striped .tr:nth-child(odd) .td {
    background: rgba(95,107,124,.15);
}
.bp5-dark .bp5-html-table.bp5-interactive .tr:hover .td {
    background-color: rgba(95,107,124,.3);
    cursor: pointer;
}

.flat {
    box-shadow: none !important;
}

.bp5-dark {
    background: #293742 !important;
}

.bp5-dark .bp5-menu {
    background: #30404d !important;
    color: #f5f8fa !important;
}

.bp5-dark .bp5-input {
    box-shadow: 0 0 0 0 rgba(45,114,210,0), 0 0 0 0 rgba(45,114,210,0), inset 0 0 0 1px rgba(17,20,24,.2), inset 0 1px 1px rgba(17,20,24,.5) !important;
}

.bp5-navbar {
    background-color: #394b59 !important;
    box-shadow: 0 0 0 1px rgba(16,22,26,.2), 0 0 0 rgba(16,22,26,0), 0 1px 1px rgba(16,22,26,.4) !important;
    height: 50px !important;
    padding: 0 15px;
    position: relative !important;
    width: 100% !important;
    z-index: 10 !important;
}

.bp5-panel-stack-view {
    background-color: #30404d !important;
}

.bp5-dark .bp5-elevation-0, .bp5-elevation-0.bp5-dark {
    box-shadow: 0 0 0 1px rgba(16,22,26,.4),0 0 0 rgba(16,22,26,0),0 0 0 rgba(16,22,26,0);
}

.bp5-card.bp5-dark, .bp5-dark .bp5-card {
    background-color: #30404d;
    box-shadow: 0 0 0 1px rgba(16,22,26,.4),0 0 0 rgba(16,22,26,0),0 0 0 rgba(16,22,26,0);
}

.bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]).bp5-disabled, .bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]):disabled {
    background-color: rgba(57,75,89,.5) ;
    background-image: none ;
    box-shadow: none ;
    color: rgba(167,182,194,.6) ;
}

.bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]).bp5-disabled, .bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]):disabled {
    background-color: rgba(57,75,89,.5) ;
    background-image: none ;
    box-shadow: none ;
    color: rgba(167,182,194,.6) ;
}

.bp5-dark .bp5-button.bp5-minimal.bp5-disabled, .bp5-dark .bp5-button.bp5-minimal.bp5-disabled:hover, .bp5-dark .bp5-button.bp5-minimal:disabled, .bp5-dark .bp5-button.bp5-minimal:disabled:hover {
    background: none ;
    color: rgba(167,182,194,.6) ;
    cursor: not-allowed ;
}

.bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]) {
    background-color: #394b59 ;
    background-image: linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0)) ;
    box-shadow: 0 0 0 1px rgba(16,22,26,.4) ;
    color: #f5f8fa ;
}

.bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]) {
    background-color: #f5f8fa ;
    background-image: linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0)) ;
    box-shadow: inset 0 0 0 1px rgba(16,22,26,.2),inset 0 -1px 0 rgba(16,22,26,.1) ;
    color: #182026 ;
}

.bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]).bp5-active, .bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]):active {
    background-color: #202b33;
    background-image: none;
    box-shadow: 0 0 0 1px rgba(16,22,26,.6),inset 0 1px 2px rgba(16,22,26,.2);
}

.bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]):hover {
    background-color: #30404d;
    box-shadow: 0 0 0 1px rgba(16,22,26,.4);
}

.bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]).bp5-active, .bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]):active, .bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]):hover {
    color: #f5f8fa;
}

.full-height {
    height: 100%
}

.main-area {
    width: 100%;
    height: calc(100vh - 50px);
    overflow: hidden;
}

.custom-tab .bp5-tab-indicator-wrapper {
    display: none;
}

.custom-tab .bp5-tab-list > *:not(:last-child) {
    margin-right: 5px !important;
}

.search-group {
    width: 1200px;
    position: relative;
    left: 50%;
    margin-left: -600px;
}
.search-group .bp5-control-group {
    width: 100%;
}

.small-image {
    width: 120px; 
    padding-top: 120px;
    height: 50px;
    background-position: center center;
    background-size: cover;
    background-color: black;
    background-repeat: no-repeat;
    float: left;
    margin: 5px;
    text-align: center;
}

.tag-counter {
    margin-left: 5px !important;
    font-size: 10px !important;
    padding: 4px !important;
    line-height: 8px !important;
    min-width: 10px !important;
    min-height: 10px !important;
}

.card-tag {
    max-width: 250px;
}

@media screen and (max-width: 1200px) {
  .hide1300 {
      display: none;
  }
  .scrollX1300 {
      overflow-x: auto;
  }
}

.singleGroupButton .bp5-button-text {
    display: flex !important;
    width: 100% !important;
}

.singleGroupButton.notexpanded .bp5-button-text {
    flex-wrap: wrap;
}

.singleGroupButton.notexpanded .bp5-button-text .articleText {
    flex-basis: 100%;
}

.highlightKeyword {
    text-decoration: underline;
    text-decoration-color: #D9822B;
    text-decoration-thickness: 5px;
}

.scroll-marker {
    width: 8px;
    pointer-events: none;
    margin-left: -14px;
    height: 100%;
    float: left;
}

.scroll-marker div {
    background-color: #D9822B;
    height: 1px;
    position: relative; 
    width: 100%;
}

.bp5-panel-stack-header {
    z-index: 2;
}

.nd-Editor {
    height: 100% !important;
    color: white !important;
}

.w-md-editor-show-live .nd-Editor {
    width: 50% !important;
}

.w-md-editor-show-edit .nd-Editor {
    width: 100% !important;
}

.nd-Editor textarea, .nd-Editor .wmde-markdown-color, .nd-Editor * , .nd-Editor .title {
    color: white !important;
}

.w-md-editor, .w-md-editor-content {
    background-color: #30404d !important;
    color: white !important;
}

.w-md-editor-content {
    border-top: 1px solid #293742 !important;
    height: calc(100% - 50px) !important;
}

.w-md-editor-bar {
    display: none;
}

.w-md-editor-text code, .w-md-editor-text textarea {
    font-family: Arial;
    line-height: 1.6;
    font-size: 1rem;
}

.w-md-editor-toolbar {
    border-radius: 0 !important;
    background-color: #394b59 !important;
    color: white;
    border: 0 !important;
    box-shadow: 0 0 0 1px rgb(16 22 26 / 20%), 0 0 0 rgb(16 22 26 / 0%), 0 1px 1px rgb(16 22 26 / 40%);
    height: 50px !important;
    margin-top: 1px;
}
.w-md-editor-toolbar svg {
    color: white !important;
}

.w-md-editor-toolbar li button:hover svg, .w-md-editor-toolbar li.active svg {
    color: #394b59 !important;
}

.bp5-panel-stack-header {
    height: 50px;
}

.bp5-panel-stack-header button {
    width: 50px;
    height: 50px;
}

.bp5-panel-stack-header .bp5-control-group {
    position: absolute;
    left: 0;
    top: 0;
}
.bp5-panel-stack-header .bp5-control-group button {
    width: auto;
    height: 49px;
}

div.player {
  display: inline-block;
  position: relative;
}
div.player img {
  max-width: 100%;
}
div.player:after {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%,-50%);
  width: 96px;
  height: 96px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) transparent top left no-repeat;
  background-size: cover;
  content: '';
  opacity: .5;
}

.videoOverlay {
    width: 845px !important;
}

.aiEditorOverlay {
    width: 90vw !important;
    max-width: 1400px !important;
    height: 90vh !important;
}

.aiEditorOverlay .bp5-dialog-body {
    margin: 0 !important;
    padding: 0 !important;
}

.hide-header .list-expanded .bp5-panel-stack-header {
    display: none !important;
}

.btn-no-padding {
    padding: unset !important;
}

.leaflet-draw.leaflet-control {
    visibility: hidden;
}

.leaflet-popup-content-wrapper .leaflet-popup-useraction-buttons {
    display: none;
}
.leaflet-popup-content-wrapper:hover .leaflet-popup-useraction-buttons {
    display: flex;
}
.leaflet-popup-content-wrapper .editing .leaflet-popup-useraction-buttons {
    display: flex;
}
.leaflet-popup-content {
    margin: 5px 10px;
}

.leaflet-popup-button.remove {
    white-space: nowrap;
    width: 45px;
    overflow: hidden;
}

.leaflet-control-zoom-in, .leaflet-control-zoom-out {
    background-color: #293742 !important;
    color: white !important;

}

.leaflet-bar a {
    border-bottom: 0 !important;
}

.comments-list .bp5-card .bp5-card {
    background: #394B59; 
}

em.highlight {
    color: #D9822B;
}

.travelFull em.highlight {
    text-decoration: underline;
    text-decoration-color: #D9822B;
    text-decoration-thickness: 5px;
}

.sourceTree ul { 
    list-style-type: none;
    margin: 0;
    padding: 0;
}
.sourceTree li {
    padding: 5px;
}


h3 {
    margin-top: 0;
}

.AIList .bp5-button-text {
    max-height: 64px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1.1rem !important;
}

.hidden {
    visibility: hidden !important;
}

.filter-panel {
    height: calc(75vh - 64px) !important;
    overflow: auto;
    width: 100% !important;
}

.filter-panel-sub {
    height: calc(75vh - 130px) !important;
    overflow: auto;
    width: 100% !important;
}

.limit-popup {
    max-height: 500px !important;
    overflow-y: auto !important;
    overflow-x: hidden;
}

.fakeBar {
    background-color: #30404d !important;
    box-shadow: 0 1px rgba(255, 255, 255, 0.2) !important;
    height: 49px !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAMA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,mJAAmJ;AACvJ;;AAEA;IACI,oCAAoC;IACpC,uGAAuG;IACvG,uBAAuB;IACvB,eAAe;IACf,6BAA6B;IAC7B,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qFAAqF;AACzF;;AAEA;IACI,yBAAyB;IACzB,qFAAqF;AACzF;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,gFAAgF;IAChF,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,+EAA+E;IAC/E,+EAA+E;IAC/E,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,yEAAyE;AAC7E;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;IAClC,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;EACE;MACI,aAAa;EACjB;EACA;MACI,gBAAgB;EACpB;AACF;;AAEA;IACI,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,oCAAoC;IACpC,YAAY;IACZ,oBAAoB;IACpB,kGAAkG;IAClG,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;AACV;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ,EAAE,SAAS;EACnB,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kFAA0D;EAC1D,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;;AAE3B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;AACA;IACI,YAAY;AAChB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,qDAAqD;IACrD,uBAAuB;AAC3B","sourcesContent":["@import \"~normalize.css\";\n@import \"~@blueprintjs/core/lib/css/blueprint.css\";\n@import \"~@blueprintjs/icons/lib/css/blueprint-icons.css\";\n@import \"~@blueprintjs/popover2/lib/css/blueprint-popover2.css\";\n@import \"~@blueprintjs/datetime/lib/css/blueprint-datetime.css\";\n\nbody, html {\n    overflow: hidden;\n    font-size: 1rem;\n    line-height: 150%;\n}\n\nh1 {\n    line-height: 1 !important;\n}\n\n.pasteInput .bp5-input-group {\n    flex: 1 !important;\n}\n\n.fullControlGroup, .fullControlGroup > .bp5-input-group, .fullControlGroup > .bp5-input-group > input[type=text] {\n    width: 100% !important;\n}\n\n.fullControlGroup > .bp5-input-group {\n    width: 100% !important;\n}\n\n.bp5-multi-select {\n    overflow: auto !important;\n    height: 30px !important;\n}\n\n.noPadding {\n    padding: 0 !important;\n}\n\n.bp5-dark .bp5-html-table .td {\n    padding: 11px;\n}\n.bp5-dark .bp5-html-table.bp5-html-table-striped .tr:nth-child(odd) .td {\n    background: rgba(95,107,124,.15);\n}\n.bp5-dark .bp5-html-table.bp5-interactive .tr:hover .td {\n    background-color: rgba(95,107,124,.3);\n    cursor: pointer;\n}\n\n.flat {\n    box-shadow: none !important;\n}\n\n.bp5-dark {\n    background: #293742 !important;\n}\n\n.bp5-dark .bp5-menu {\n    background: #30404d !important;\n    color: #f5f8fa !important;\n}\n\n.bp5-dark .bp5-input {\n    box-shadow: 0 0 0 0 rgba(45,114,210,0), 0 0 0 0 rgba(45,114,210,0), inset 0 0 0 1px rgba(17,20,24,.2), inset 0 1px 1px rgba(17,20,24,.5) !important;\n}\n\n.bp5-navbar {\n    background-color: #394b59 !important;\n    box-shadow: 0 0 0 1px rgba(16,22,26,.2), 0 0 0 rgba(16,22,26,0), 0 1px 1px rgba(16,22,26,.4) !important;\n    height: 50px !important;\n    padding: 0 15px;\n    position: relative !important;\n    width: 100% !important;\n    z-index: 10 !important;\n}\n\n.bp5-panel-stack-view {\n    background-color: #30404d !important;\n}\n\n.bp5-dark .bp5-elevation-0, .bp5-elevation-0.bp5-dark {\n    box-shadow: 0 0 0 1px rgba(16,22,26,.4),0 0 0 rgba(16,22,26,0),0 0 0 rgba(16,22,26,0);\n}\n\n.bp5-card.bp5-dark, .bp5-dark .bp5-card {\n    background-color: #30404d;\n    box-shadow: 0 0 0 1px rgba(16,22,26,.4),0 0 0 rgba(16,22,26,0),0 0 0 rgba(16,22,26,0);\n}\n\n.bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]).bp5-disabled, .bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]):disabled {\n    background-color: rgba(57,75,89,.5) ;\n    background-image: none ;\n    box-shadow: none ;\n    color: rgba(167,182,194,.6) ;\n}\n\n.bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]).bp5-disabled, .bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]):disabled {\n    background-color: rgba(57,75,89,.5) ;\n    background-image: none ;\n    box-shadow: none ;\n    color: rgba(167,182,194,.6) ;\n}\n\n.bp5-dark .bp5-button.bp5-minimal.bp5-disabled, .bp5-dark .bp5-button.bp5-minimal.bp5-disabled:hover, .bp5-dark .bp5-button.bp5-minimal:disabled, .bp5-dark .bp5-button.bp5-minimal:disabled:hover {\n    background: none ;\n    color: rgba(167,182,194,.6) ;\n    cursor: not-allowed ;\n}\n\n.bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]) {\n    background-color: #394b59 ;\n    background-image: linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0)) ;\n    box-shadow: 0 0 0 1px rgba(16,22,26,.4) ;\n    color: #f5f8fa ;\n}\n\n.bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]) {\n    background-color: #f5f8fa ;\n    background-image: linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0)) ;\n    box-shadow: inset 0 0 0 1px rgba(16,22,26,.2),inset 0 -1px 0 rgba(16,22,26,.1) ;\n    color: #182026 ;\n}\n\n.bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]).bp5-active, .bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]):active {\n    background-color: #202b33;\n    background-image: none;\n    box-shadow: 0 0 0 1px rgba(16,22,26,.6),inset 0 1px 2px rgba(16,22,26,.2);\n}\n\n.bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]):hover {\n    background-color: #30404d;\n    box-shadow: 0 0 0 1px rgba(16,22,26,.4);\n}\n\n.bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]).bp5-active, .bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]):active, .bp5-dark .bp5-button:not([class*=bp5-intent-]):not([class*=bp5-minimal]):hover {\n    color: #f5f8fa;\n}\n\n.full-height {\n    height: 100%\n}\n\n.main-area {\n    width: 100%;\n    height: calc(100vh - 50px);\n    overflow: hidden;\n}\n\n.custom-tab .bp5-tab-indicator-wrapper {\n    display: none;\n}\n\n.custom-tab .bp5-tab-list > *:not(:last-child) {\n    margin-right: 5px !important;\n}\n\n.search-group {\n    width: 1200px;\n    position: relative;\n    left: 50%;\n    margin-left: -600px;\n}\n.search-group .bp5-control-group {\n    width: 100%;\n}\n\n.small-image {\n    width: 120px; \n    padding-top: 120px;\n    height: 50px;\n    background-position: center center;\n    background-size: cover;\n    background-color: black;\n    background-repeat: no-repeat;\n    float: left;\n    margin: 5px;\n    text-align: center;\n}\n\n.tag-counter {\n    margin-left: 5px !important;\n    font-size: 10px !important;\n    padding: 4px !important;\n    line-height: 8px !important;\n    min-width: 10px !important;\n    min-height: 10px !important;\n}\n\n.card-tag {\n    max-width: 250px;\n}\n\n@media screen and (max-width: 1200px) {\n  .hide1300 {\n      display: none;\n  }\n  .scrollX1300 {\n      overflow-x: auto;\n  }\n}\n\n.singleGroupButton .bp5-button-text {\n    display: flex !important;\n    width: 100% !important;\n}\n\n.singleGroupButton.notexpanded .bp5-button-text {\n    flex-wrap: wrap;\n}\n\n.singleGroupButton.notexpanded .bp5-button-text .articleText {\n    flex-basis: 100%;\n}\n\n.highlightKeyword {\n    text-decoration: underline;\n    text-decoration-color: #D9822B;\n    text-decoration-thickness: 5px;\n}\n\n.scroll-marker {\n    width: 8px;\n    pointer-events: none;\n    margin-left: -14px;\n    height: 100%;\n    float: left;\n}\n\n.scroll-marker div {\n    background-color: #D9822B;\n    height: 1px;\n    position: relative; \n    width: 100%;\n}\n\n.bp5-panel-stack-header {\n    z-index: 2;\n}\n\n.nd-Editor {\n    height: 100% !important;\n    color: white !important;\n}\n\n.w-md-editor-show-live .nd-Editor {\n    width: 50% !important;\n}\n\n.w-md-editor-show-edit .nd-Editor {\n    width: 100% !important;\n}\n\n.nd-Editor textarea, .nd-Editor .wmde-markdown-color, .nd-Editor * , .nd-Editor .title {\n    color: white !important;\n}\n\n.w-md-editor, .w-md-editor-content {\n    background-color: #30404d !important;\n    color: white !important;\n}\n\n.w-md-editor-content {\n    border-top: 1px solid #293742 !important;\n    height: calc(100% - 50px) !important;\n}\n\n.w-md-editor-bar {\n    display: none;\n}\n\n.w-md-editor-text code, .w-md-editor-text textarea {\n    font-family: Arial;\n    line-height: 1.6;\n    font-size: 1rem;\n}\n\n.w-md-editor-toolbar {\n    border-radius: 0 !important;\n    background-color: #394b59 !important;\n    color: white;\n    border: 0 !important;\n    box-shadow: 0 0 0 1px rgb(16 22 26 / 20%), 0 0 0 rgb(16 22 26 / 0%), 0 1px 1px rgb(16 22 26 / 40%);\n    height: 50px !important;\n    margin-top: 1px;\n}\n.w-md-editor-toolbar svg {\n    color: white !important;\n}\n\n.w-md-editor-toolbar li button:hover svg, .w-md-editor-toolbar li.active svg {\n    color: #394b59 !important;\n}\n\n.bp5-panel-stack-header {\n    height: 50px;\n}\n\n.bp5-panel-stack-header button {\n    width: 50px;\n    height: 50px;\n}\n\n.bp5-panel-stack-header .bp5-control-group {\n    position: absolute;\n    left: 0;\n    top: 0;\n}\n.bp5-panel-stack-header .bp5-control-group button {\n    width: auto;\n    height: 49px;\n}\n\ndiv.player {\n  display: inline-block;\n  position: relative;\n}\ndiv.player img {\n  max-width: 100%;\n}\ndiv.player:after {\n  position: absolute;\n  top: 50%; left: 50%;\n  transform: translate(-50%,-50%);\n  width: 96px;\n  height: 96px;\n  background: url('play.png') transparent top left no-repeat;\n  background-size: cover;\n  content: '';\n  opacity: .5;\n}\n\n.videoOverlay {\n    width: 845px !important;\n}\n\n.aiEditorOverlay {\n    width: 90vw !important;\n    max-width: 1400px !important;\n    height: 90vh !important;\n}\n\n.aiEditorOverlay .bp5-dialog-body {\n    margin: 0 !important;\n    padding: 0 !important;\n}\n\n.hide-header .list-expanded .bp5-panel-stack-header {\n    display: none !important;\n}\n\n.btn-no-padding {\n    padding: unset !important;\n}\n\n.leaflet-draw.leaflet-control {\n    visibility: hidden;\n}\n\n.leaflet-popup-content-wrapper .leaflet-popup-useraction-buttons {\n    display: none;\n}\n.leaflet-popup-content-wrapper:hover .leaflet-popup-useraction-buttons {\n    display: flex;\n}\n.leaflet-popup-content-wrapper .editing .leaflet-popup-useraction-buttons {\n    display: flex;\n}\n.leaflet-popup-content {\n    margin: 5px 10px;\n}\n\n.leaflet-popup-button.remove {\n    white-space: nowrap;\n    width: 45px;\n    overflow: hidden;\n}\n\n.leaflet-control-zoom-in, .leaflet-control-zoom-out {\n    background-color: #293742 !important;\n    color: white !important;\n\n}\n\n.leaflet-bar a {\n    border-bottom: 0 !important;\n}\n\n.comments-list .bp5-card .bp5-card {\n    background: #394B59; \n}\n\nem.highlight {\n    color: #D9822B;\n}\n\n.travelFull em.highlight {\n    text-decoration: underline;\n    text-decoration-color: #D9822B;\n    text-decoration-thickness: 5px;\n}\n\n.sourceTree ul { \n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n}\n.sourceTree li {\n    padding: 5px;\n}\n\n\nh3 {\n    margin-top: 0;\n}\n\n.AIList .bp5-button-text {\n    max-height: 64px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 1.1rem !important;\n}\n\n.hidden {\n    visibility: hidden !important;\n}\n\n.filter-panel {\n    height: calc(75vh - 64px) !important;\n    overflow: auto;\n    width: 100% !important;\n}\n\n.filter-panel-sub {\n    height: calc(75vh - 130px) !important;\n    overflow: auto;\n    width: 100% !important;\n}\n\n.limit-popup {\n    max-height: 500px !important;\n    overflow-y: auto !important;\n    overflow-x: hidden;\n}\n\n.fakeBar {\n    background-color: #30404d !important;\n    box-shadow: 0 1px rgba(255, 255, 255, 0.2) !important;\n    height: 49px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
